var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.kirby.page.template == "share-story")?_c('main',{attrs:{"id":"Share"}},[_vm._m(0)]):_vm._e()
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('iframe',{attrs:{"title":"Penn Medicine Listening Lab | Donate your Story","allowtransparency":"true","allowfullscreen":"true","allow":"geolocation; microphone; camera","width":"100%","height":"100%","src":"https://form.jotform.com/201934052777155"}})
}]

export { render, staticRenderFns }